<template>
    <div class="panel modalDetailsPanel" v-if="usecase">

        <ol class="panelDetails">
            <li><span>Status</span><span>{{ usecase.status }}</span></li>
            <li><span>Type</span><span>{{ usecase.type }}</span></li>
            <li><span>Increment</span><span>{{ usecase.increment }}</span></li>
            <li><span>Interessegebied</span><span>{{ usecase.area_of_interest }}</span></li>
            <li><span>Gecontracteerd voor</span><span>{{ usecase.contracted_for }}</span></li>
            <li><span>Gecontractbedrag</span><span>{{ this.$filters.formatPrice(usecase.contract_amount) }}</span></li>
        </ol>
    </div>
</template>

<script>
export default {
    props: {
        usecase: {
            type: Object,
            required: true
        }
    }
}
</script>